export class EntReservoirHistoryFilter {
  id?: string; 
  reservoirId: number | null;
  dateForDayFrom: string | null;
  dateForDayTo: string | null;
  deleted: boolean = false;
  page: number;
  size: number;

  constructor(init?:Partial<EntReservoirHistoryFilter>) {
    this.reservoirId = null;
    this.dateForDayFrom = null;
    this.dateForDayTo = null;
    this.deleted = false;
    this.deleted = false;
    this.page = 1;
    this.size = 30;
    if(init){
      Object.assign(this, init)
    }
  }
}
